import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { LogIn, ArrowLeft } from 'lucide-react'
import { useAuth } from '../auth/AuthContext'

export function Login() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await login(username, password)
      navigate('/admin', { replace: true })
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Identifiants invalides')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="grid min-h-screen place-items-center bg-navy px-5">
      <div className="w-full max-w-sm">
        <Link to="/" className="mb-6 inline-flex items-center gap-2 text-sm text-white/60 transition-colors hover:text-white">
          <ArrowLeft className="h-4 w-4" /> Retour au site
        </Link>

        <form onSubmit={submit} className="space-y-5 rounded-3xl border border-white/10 bg-white p-8 shadow-soft">
          <div className="flex items-center gap-2.5 rounded-xl bg-navy px-4 py-3">
            <img src="/img/logo-maison-gilles.png" alt="" className="h-10 w-10" />
            <img src="/img/logo-complet.png" alt="Maison Gilles SA" className="h-5 w-auto" />
          </div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-orange">Espace administrateur</p>

          <div className="space-y-1.5">
            <label htmlFor="login-user" className="block text-xs font-semibold uppercase tracking-wider text-ink/50">Utilisateur</label>
            <input
              id="login-user"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              className="w-full rounded-xl border border-navy/15 bg-sand px-3.5 py-2.5 text-sm outline-none transition-colors focus:border-orange"
            />
          </div>
          <div className="space-y-1.5">
            <label htmlFor="login-pass" className="block text-xs font-semibold uppercase tracking-wider text-ink/50">Mot de passe</label>
            <input
              id="login-pass"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border border-navy/15 bg-sand px-3.5 py-2.5 text-sm outline-none transition-colors focus:border-orange"
            />
          </div>

          {error && <div className="rounded-lg bg-orange/10 px-3 py-2 text-sm text-orange-dk">{error}</div>}

          <button
            disabled={busy}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-navy px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-navy-dk disabled:opacity-50"
          >
            <LogIn className="h-4 w-4" />
            {busy ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  )
}
